import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

import { ScheduleBlock, ScheduleBlockItem } from '@/tools/models/class-builder.models';

@Component({
  name: 'ed-class-schedule-remove-block-modal',
  components: {
    EdBlockItem: () => import(/* "EdBlockItem" */ '../ed-block-item/ed-block-item.component.vue'),
  },
})
export default class EdClassScheduleRemoveBlockModalComponent extends Vue {

  @Prop({ default: null }) readonly params: any;

  get block (): ScheduleBlock {
    return this.params.block;
  }

  emitOnRemoveBlock() {
    this.close();

    this.params.onRemoveBlock(this.block);
  }

  close() {
    this.$EdModal.closeModal();
  }
}